module.exports = __webpack_public_path__ + "assets/img/4e7e3c3b58a48f2ac7f26c1c88857da5.png";